import TurndownService from 'turndown';

import { turndownGfmTables } from './turndownGfmTables';
import { turndownQuillLists } from './turndownQuillLists';

const turndownService = new TurndownService({
  headingStyle: 'atx',
  bulletListMarker: '-',
});

turndownService.use(turndownGfmTables);
turndownService.use(turndownQuillLists);

/** Keep <s> in output so MarkdownText can render strikethrough */
turndownService.keep(['s']);

/** Normalize strikethrough to <s> so Turndown keep works */
function normalizeStrikethrough(html: string): string {
  return html
    .replace(/<strike\b[^>]*>(.*?)<\/strike>/gis, '<s>$1</s>')
    .replace(/<del\b[^>]*>(.*?)<\/del>/gis, '<s>$1</s>')
    .replace(
      /<span[^>]*style=["'][^"']*text-decoration:\s*line-through[^"']*["'][^>]*>(.*?)<\/span>/gis,
      '<s>$1</s>'
    );
}

/**
 * Converts HTML to Markdown. Safe to call with plain text or already markdown
 * (returns unchanged if string does not look like HTML).
 */
export function htmlToMarkdown(html: string): string {
  const trimmed = html?.trim() ?? '';

  if (trimmed === '') return '';

  const looksLikeHtml = /<[a-zA-Z][\s\S]*>/i.test(trimmed);

  if (!looksLikeHtml) return trimmed;

  const normalized = normalizeStrikethrough(trimmed);

  try {
    return turndownService.turndown(normalized);
  } catch {
    return trimmed;
  }
}
